export const PAGINATION = 'PAGINATION';
export const IS_EDITING = 'IS_EDITING';
